import React, { useEffect, useState } from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import { AutoComplete, Divider } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Grid } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { DatePicker, Space } from 'antd';
import { Modal } from 'antd';
import type { DatePickerProps } from 'antd';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Skeleton from '@mui/material/Skeleton';
import { Button } from 'antd';
import {
	fetchCityDispatch,
	AddSearchFlightDispatch,
} from '../reducers/HomeReducer';
import { useLocation, useNavigate } from 'react-router-dom';
import FlightResultSkeleton from '../components/resuableComponents/FlightResultSkeleton';
import TopDrawer from '../components/resuableComponents/TopDrawer';
import { AddSearchFlightFDDispatch } from '../reducers/FDReducer';
import {
	addBusSearchDispatch,
	fetchBusCityDesDispatch,
	fetchSeatLayoutDispatch,
} from '../reducers/BusReducer';
import {
	setSelectedBusArr,
	setSelectedBusDepart,
	setSelectedTripID,
} from '../reducers/UiReducer';
import { Showseat } from '../components/resuableComponents/ShowSeat';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import { hotelSearchDispatch } from '../reducers/HotelReducer';
import ModifySearchFlight from '../components/resuableComponents/ModifySearchFlight';
import ModifyHotel from '../components/resuableComponents/ModifyHotel';

const Option = AutoComplete.Option;
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const SearchResultHotel = () => {
	const { city, loadinghome } = useSelector((state) => state.home);
	const { busSearch, layoutloading, seatLayout, buscity, busDes } = useSelector(
		(state) => state.bus
	);
	const { tripid, busDepart, busArr } = useSelector((state) => state.ui);
	const { hotelresult } = useSelector((state) => state.hotel);
	const dispatch = useDispatch();
	const [departDate, setDepartDate] = useState('');
	const [draw, setDraw] = useState(false);
	const [loadings, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [filterDataD, setFilterDataD] = useState('');
	const [filterData2, setFilterData2] = useState('');
	const [scrollVal, SetScrollVal] = useState(10);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();
	console.log('location', location);
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log(date, dateString);
		setDepartDate(dateString);
	};
	const showModal = () => {
		setOpen(true);
	};

	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleCancel = () => {
		setOpen(false);
	};
	function timeConvertbus(a) {
		let arhour = Math.floor(a / 60);
		if (arhour > 24) {
			arhour = arhour - 24;
		}
		let armin = a % 60;
		let format = `${arhour}:${armin === 0 ? '00' : armin}:00`;
		function formatTime(timeString) {
			const [hourString, minute] = timeString.split(':');
			const hour = +hourString % 24;
			return (hour % 12 || 12) + ':' + minute + (hour < 12 ? ' AM' : ' PM');
		}
		return formatTime(format);
		console.log('first', armin);
	}
	const fetchMoreData = () => {
		// if (eltbo === fals && letrav === false && trp === false) {
		// 	if (scrollVal >= filterData.length) {
		// 		SethasMoreFilterData(false);
		// 	}
		// }

		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};
	const handleChange = (value) => {
		let results = [];
		console.log('value', value.split(',')[1]);
		results =
			buscity &&
			buscity?.result &&
			buscity?.result?.cities?.filter((item) => {
				return (
					item.name.toLowerCase().includes(value.toLowerCase()) ||
					item.state.toLowerCase().includes(value.toLowerCase())
				);
			});
		if (value) {
			dispatch(setSelectedBusDepart(value));
			let formData = {
				source: value.split(',')[1],
			};
			dispatch(fetchBusCityDesDispatch(formData));
		}
		console.log('results', results);
		if (results?.length <= 80) {
			setFilterDataD(results);
		}
	};
	let filterData = [];
	filterData =
		hotelresult &&
		hotelresult?.result &&
		hotelresult?.result?.HotelSearchResult &&
		hotelresult?.result?.HotelSearchResult?.HotelResults?.length > 0 &&
		hotelresult?.result?.HotelSearchResult?.HotelResults?.slice().sort(
			(a, b) => {
				return a.Price.RoomPrice - b.Price.RoomPrice;
			}
		);
	const opsList =
		filterDataD?.length > 0 &&
		filterDataD?.map((l) => {
			return (
				<Option
					value={`${l.name} - ${l.state},${l.id}`}>{`${l.name} - ${l.state},${l.id} `}</Option>
			);
		});
	const handleChange2 = (value) => {
		let results = [];
		results =
			busDes &&
			busDes?.result &&
			busDes?.result?.cities?.filter((item) => {
				return (
					item.name.toLowerCase().includes(value.toLowerCase()) ||
					item.state.toLowerCase().includes(value.toLowerCase())
				);
			});
		console.log('searchresult', results);
		if (value) {
			dispatch(setSelectedBusArr(value));
		}
		if (results?.length < 80) {
			setFilterData2(results);
		}
	};
	const opsList2 =
		filterData2?.length > 0 &&
		filterData2?.map((l) => {
			return (
				<Option
					value={`${l.name} - ${l.state},${l.id}`}>{`${l.name} - ${l.state},${l.id} `}</Option>
			);
		});
	console.log('fILTER', filterData);
	const handleSubmit = () => {
		let formData = {
			departure_city: busDepart.split(' ')[0],
			arrival_city: busArr.split(' ')[0],
			sourceid: busDepart.split(',')[1],
			destinationid: busArr.split(',')[1],
			dateofjourney: departDate,
		};
		console.log('formData', formData);
		navigate('/searchresultbus', { state: formData });
	};
	useEffect(() => {
		dispatch(hotelSearchDispatch(location.state));
		// dispatch(AddSearchFlightFDDispatch(location.state));
	}, [location.state]);
	return (
		<div>
			<Navbar />
			{filterData?.length > 0 ? (
				<>
					<ModifyHotel />
					<Box
						style={{
							background: '#FFF',
							boxShadow: '0 0 10px rgba(0,0,0,.3)',

							paddingTop: 10,
						}}>
						<Container>
							<Grid container spacing={2}>
								<Grid item xs={3}>
									<Box>
										<span>Hotel Name</span>
									</Box>
									<Box style={{ display: 'flex' }}>
										<input
											type='search'
											style={{
												border: '1px solid lightgrey',
												marginTop: 5,
												marginBottom: 5,
												borderRadius: 5,
												padding: 6,
											}}
										/>
									</Box>
								</Grid>
								<Grid item xs={6}>
									<Box>
										<span>Star Rating</span>
									</Box>
									<Box style={{ display: 'flex' }}>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>0/1 Star</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>2 Star</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>3 Star</span>
										</Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} />
											<span style={{ fontSize: 12 }}>4 Star</span>
										</Box>
									</Box>
								</Grid>
								<Grid item xs={3}>
									<Box>
										<span>Hotel Location</span>
									</Box>
									<Box style={{ display: 'flex' }}>
										<input
											type='search'
											style={{
												border: '1px solid lightgrey',
												marginTop: 5,
												marginBottom: 5,
												borderRadius: 5,
												padding: 6,
											}}
										/>
									</Box>
								</Grid>
							</Grid>
						</Container>
					</Box>
				</>
			) : (
				''
			)}

			<Container>
				<Box
					style={{
						marginTop: 50,
						marginBottom: 50,
						// paddingLeft: 100,
						// paddingRight: 100,
					}}>
					{/* <Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<h2 style={{ fontSize: 20 }}>{`Bus From ${
							location.state.departure_city
						} to ${location.state.arrival_city}(${
							filterData?.length ? filterData?.length : ''
						})`}</h2>
						<h3 style={{ fontSize: 20 }}>{location.state.dateofjourney}</h3>
					</Box> */}
					<Grid container spacing={4}>
						<Grid item xs={12} lg={8}>
							{filterData?.length > 0 ? (
								<InfiniteScroll
									dataLength={scrollVal}
									next={fetchMoreData}
									hasMore={hasMorefilterData}
									loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
									endMessage={
										<p style={{ textAlign: 'center' }}>
											<b>No More Flights</b>
										</p>
									}>
									{filterData?.map((item, index) => {
										return index < scrollVal ? (
											<>
												<div className='searchItem' style={{ display: 'flex' }}>
													<img
														src={item.HotelPicture}
														alt=''
														className='siImg'
													/>
													<div className='siDesc'>
														<h1 className='siTitle'>{item.HotelName}</h1>
														<span className='siDistance'>
															{item.HotelAddress}
														</span>
														{/* <span className="siTaxiOp">Free airport taxi</span> */}
														<span
															className='siSubtitle'
															style={{
																width: '50ch',
																overflow: 'hidden',
																whiteSpace: 'nowrap',
																textOverflow: 'ellipsis',
															}}>
															{item.HotelDescription}
														</span>
														<span className='siFeatures'>
															Entire studio • 1 bathroom • 21m² 1 full bed
														</span>
														<span className='siCancelOp'>
															Free cancellation{' '}
														</span>
														<span className='siCancelOpSubtitle'>
															You can cancel later, so lock in this great price
															today!
														</span>
													</div>
													<div className='siDetails'>
														<div className='siRating'>
															<span>Excellent</span>
															<button>{`${item.StarRating}/5`}</button>
														</div>
														<div className='siDetailTexts'>
															<span
																className='siPrice'
																style={{ textDecoration: 'line-through' }}>
																₹{Number(Math.round(Number(item.Total_Amount)))}
															</span>
															<span className='siPrice'>
																₹
																{Number(
																	Math.round(
																		Number(item.Total_Amount) -
																			Number(item.MFB_Discount)
																	)
																)}
															</span>
															<span className='siTaxOp'>
																Includes taxes and fees
															</span>
															<button
																className='siCheckButton'
																onClick={() => {
																	let form = {
																		resultIndex: item.ResultIndex,
																		hotelcode: item.HotelCode,
																		traceId:
																			hotelresult.result.HotelSearchResult
																				.TraceId,
																	};
																}}>
																See availability
															</button>
														</div>
													</div>
												</div>
											</>
										) : (
											''
										);
									})}
								</InfiniteScroll>
							) : (
								Array.from(Array(10)).map((i) => {
									return <FlightResultSkeleton />;
								})
							)}
						</Grid>
						<Grid item xs={12} lg={4}>
							<Box>
								<img src='https://tpc.googlesyndication.com/simgad/16156858053234787891?sqp=4sqPyQQrQikqJwhfEAEdAAC0QiABKAEwCTgDQPCTCUgAUAFYAWBfcAJ4AcUBLbKdPg&rs=AOga4qmd7sh5rWiWjxdzaN9vw44WnXQdZA' />
							</Box>
						</Grid>
					</Grid>
				</Box>
			</Container>
			<TopDrawer draw={draw} setDraw={setDraw} />
			<Footer />
		</div>
	);
};

export default SearchResultHotel;
